// extracted by mini-css-extract-plugin
export default {"container":"ProtectedRoute_container__+J+S5"};